<template>
  <v-card>
    <v-card-text>
      <small><b>{{ $t('payment.application.chosenMilestones') }}</b></small>
      <v-data-table
        dense
        :headers="headers"
        :items="milestones"
        hide-default-footer
        item-key="key"
        :items-per-page="-1"
      >
        <template v-slot:item.partAmountCents="{ item }">
          {{item.partAmountCents |  formatCurrency({ key: item.currency.key, value: 1 }) }}
        </template>
        <template v-slot:item.paymentPart="{ item }">
          {{item.paymentPart | toFixed}}%
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { prepareSelectedMilestonesItem } from '@/services'

export default {
  name: 'PaymentApplicationMilestonesTable',
  props: {
    paymentMilestones: Array,
    paymentApplications: Array,
    chosenCurrency: Object,
    currencies: Array
  },
  data () {
    return {
      headers: [
        { text: this.$t('payment.application.partName'), value: 'name' },
        { text: this.$t('payment.application.partPayment'), value: 'paymentPart' },
        { text: this.$t('payment.application.partAmount'), value: 'partAmountCents' }
      ]
    }
  },
  computed: {
    milestones () {
      return this.paymentMilestones.map(i => prepareSelectedMilestonesItem(this.paymentApplications, i, this.currencies))
    }
  }
}
</script>
